<template>
  <div class="container-fluid">
    <Card back>
      <template slot="header">
        <h3>مدیریت کاتالوگ محصولات</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row" v-if="AddMode">
          <div class="col-12">
            <h5>
              <!-- ثبت کاتالوگ برای <span class="font-weight-bold text-info">{{ this.product.Name }} </span> -->
            </h5>
          </div>
          <div class="col-lg-8 col-12 mt-2">
            <small id="Lbltitle">عنوان کاتالوگ</small>
            <input type="text" id="title" class="form-control" v-model="Data.title" />
          </div>
          <div class="col-lg-4 col-12 mt-2"></div>
          <div class="col-12">
            <small id="LblDes">توضیحات</small>
            <textarea class="form-control" v-model="Data.Des"> </textarea>
          </div>
          <div class="col-lg-6 col-12 mt-2">
            <div class="m-2 border border-secondary Rounded p-2">
              <small>تصویر شاخص</small>
              <Uploader @upload="GetmainPIc"></Uploader>
            </div>
          </div>
          <div class="col-lg-6 col-12 mt-2">
            <div class="m-2 border border-secondary Rounded p-2">
              <small> بارگذاری فایل</small>
              <uploader @upload="GetFile"></uploader>
            </div>
          </div>
          <div class="col-lg-2 col-12 mt-2">
            <small id="lblShowInSlides">نمایش در اسلایدر</small>

            <div class="custom-control custom-switch mt-2">
              <input type="checkbox" class="custom-control-input InputText" id="ShowInSlides" v-model="Data.ShowInSlides" />
              <label class="custom-control-label mr-2" for="ShowInSlides"> </label>
            </div>
          </div>
          <div class="col-lg-6 col-12 mt-2"></div>
          <div class="col-lg-4 col-12 mt-2">
            <button v-if="Edit" class="btn btn-success w-100" @click="EditCatalog">ثبت اصلاح</button>
            <button v-else class="btn btn-success w-100" @click="Submit">ثبت کاتالوگ</button>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-12">
            <BnpGrid :action="true" :propsRows="LIstCatalog" :propsColumn="columns" :NoRowNum="true" v-if="$store.state.renderComponentGrid">
              <template slot="action-slot" slot-scope="props">
                <a href="javascript:;" class="mr-2 badge" @click="OnDetail(props.props)"
                  ><h6><span class="fas fa-pen font-weight-bold hover-danger"></span></h6
                ></a>
                <a href="javascript:;" class="mr-2 badge" @click="DeleteQ(props.props)"
                  ><h6><span class="fas fa-trash font-weight-bold hover-danger"></span></h6
                ></a>
              </template>
              <template slot="pic" slot-scope="props">
                <img :src="$cookies.get('URL') + props.props.filepathMainPIC + props.props.filenameMainPIC" />
              </template>
              <template slot="file" slot-scope="props">
                <a v-if="props.props.filenamefile != null" target="_blank" :href="$cookies.get('URL') + props.props.filepathfile + props.props.filenamefile" class="mr-2 badge"
                  ><h6><span class="fas fa-file font-weight-bold hover-danger"></span></h6
                ></a>
              </template>
              <template slot="des" slot-scope="props">
                <span :data-title="props.props.des"> {{ props.props.des && props.props.des.length > 50 ? props.props.des.slice(0, 50) + '...' : props.props.des }}</span>
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Uploader from '@/components/Uploader/Uploader.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  props: ['product', 'newCat'],
  data() {
    return {
      AddMode: true,
      LIstCatalog: [],
      error: false,
      Data: { title: '', Des: '', tblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId, DateTimeInsert: '', ShowInSlides: false },
      file: null,
      MainPic: null,
      columns: [
        { id: 5, name: 'nameproduct', visibility: true, width: 329, indexCol: 1, label: 'نام محصول' },
        { id: 6, name: 'title', visibility: true, width: 329, indexCol: 1, label: 'عنوان کاتالوگ' },
        { id: 7, name: 'des', visibility: true, width: 329, indexCol: 1, label: 'توضیحات' },
        { id: 7, name: 'pic', visibility: true, width: 329, indexCol: 1, label: 'تصویر' },
        { id: 7, name: 'file', visibility: true, width: 329, indexCol: 1, label: 'فایل' },
      ],
      Edit: false,
    }
  },
  created() {
    if (this.product) {
      this.AddMode = true
    } else {
      this.AddMode = false
      this.LoadData()
    }
  },
  components: { Card, Uploader, BnpGrid },
  methods: {
    GetmainPIc(data) {
      this.MainPic = data
    },
    GetFile(data) {
      this.file = data
    },
    Submit() {
      var formData = new FormData()
      formData.append('Id', 11)
      formData.append('tblProductsId', this.product.Id)
      formData.append('tblUserGrpIdInsert', this.Data.tblUserGrpIdInsert)
      formData.append('DateTimeLastEdit', null)
      formData.append('title', this.Data.title)
      formData.append('Des', this.Data.Des)
      formData.append('tblUserGrpIdLastEdit', null)
      formData.append('file', this.file)
      formData.append('MainPic', this.MainPic)
      var DataAxios = { Action: 'Catlog/Insert', Method: 'POST', ArryfildValue: formData }
      this.$PostFormData(DataAxios)
        .then((result) => {
          if (result.status == 'success') {
            this.AddMode = false
            this.$mySweetDefaultTost('عملیات موفق', 'کاتالوگ جدید با موفقیت ثبت شد', 'success', 2000)
            this.$emit('Inserted', {
              done: 'OK',
            })
            this.LoadData()
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ثبت بوجود امده است', 'warning', 2000)
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سیستم', 'error', 2000)
          console.error(error)
        })
    },
    OnDetail(data) {
      this.MainPic = null
      this.file = null
      this.Data.DateTimeInsert = data.dateTimeInsertPC
      this.Data.tblUserGrpIdInsert = data.usergrpinsertPC
      this.Data.Des = data.des
      this.Data.title = data.title
      this.Data.Id = data.id
      this.Data.ShowInSlides = data.showInSlides
      this.Data.tblProductsId = data.tblProductsId
      this.Data.tblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.AddMode = true
      this.Edit = true
    },
    LoadData() {
      var DataAxiosGet = { Action: 'Catlog/Index', Method: 'POST', ArryfildValue: null }
      this.$PostData(DataAxiosGet).then((result) => {
        var sorted = []

        this.LIstCatalog = result.data
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
      })
    },
    EditCatalog() {
      var formData = new FormData()
      formData.append('Id', this.Data.Id)
      formData.append('tblProductsId', this.Data.tblProductsId)
      formData.append('tblUserGrpIdInsert', this.Data.tblUserGrpIdInsert)
      formData.append('DateTimeInsert', this.Data.DateTimeInsert)
      formData.append('DateTimeLastEdit', null)
      formData.append('ShowInSlides', this.Data.ShowInSlides)
      formData.append('title', this.Data.title)
      formData.append('Des', this.Data.Des)
      formData.append('tblUserGrpIdLastEdit', null)
      formData.append('file', this.file)
      formData.append('MainPic', this.MainPic)
      var DataAxios = { Action: 'Catlog/Edit', Method: 'POST', ArryfildValue: formData }
      this.$PostFormData(DataAxios)
        .then((result) => {
          if (result.status == 'success') {
            this.AddMode = false
            this.$mySweetDefaultTost('عملیات موفق', 'نامه جدید با موفقیت ثبت شد', 'success', 2000)
            this.$emit('Inserted', {
              done: 'OK',
            })
            this.LoadData()
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'مشکلی در ثبت بوجود امده است', 'warning', 2000)
          }
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سیستم', 'error', 2000)
          console.error(error)
        })
    },
    DeleteQ(data) {
      this.$SweetQustion('هشدار', 'ایا از حذف کاتالوگ اطمینان دارید؟', 'info', 'بله', 'انصراف', data, this.DeleteCatalog, this.cancel)
    },
    DeleteCatalog(data) {
      console.warn(data.id)
      var DataAxiosDelete = { Method: 'POST', Action: 'Catlog/Delete', ArryfildValue: { Id: data.id } }
      this.$PostData(DataAxiosDelete).then((result) => {
        if (result.status == 'success') {
          this.LoadData()
        }
      })
    },
  },
}
</script>
<style scoped>
.Rounded {
  border-radius: 5px !important;
}
img {
  max-height: 8vh !important ;
}
</style>
